import { _notNil } from '@/littledash';

export type CascadeDeleteChildType = 'samples' | 'measurements' | 'observations' | 'dosages';

export type CascadeDeleteOptions = Record<CascadeDeleteChildType, boolean>;

export const CASCADE_DELETE_CHILD_OPTIONS: Array<[CascadeDeleteChildType, string]> = [
  ['samples', 'Samples'],
  ['measurements', 'Measurements'],
  ['observations', 'Observations'],
  ['dosages', 'Dosages'],
];

export const UNCHECKED_CASCADE_DELETE_OPTIONS: CascadeDeleteOptions = {
  samples: false,
  measurements: false,
  observations: false,
  dosages: false,
};

export const hasSelectedCascadeOption = (cascade?: CascadeDeleteOptions): boolean =>
  _notNil(cascade) && CASCADE_DELETE_CHILD_OPTIONS.some(([name]) => cascade[name]);
